import { cn } from 'src/shared/utils/cn'

interface DotListProps {
  items: (string | null | undefined)[]
  textClassName?: string
  dotClassName?: string
  dotText?: string
  className?: string
}

export default function DotList({ items, className, textClassName, dotText = '•', dotClassName }: DotListProps) {
  const filteredItems = items.filter(Boolean)

  return (
    <div>
      {filteredItems.map((item, index) => {
        return (
          <span key={index} className={className}>
            <span className={cn('text-sm text-muted', textClassName)}>{item}</span>
            {index !== filteredItems.length - 1 && (
              <span className={cn('inline-block px-1 text-sm text-muted', dotClassName)}>{dotText}</span>
            )}
          </span>
        )
      })}
    </div>
  )
}
